import _toConsumableArray from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { getBreakpointValue, getSize } from '@mantine/styles';
function getSortedBreakpoints(theme, breakpoints) {
  if (breakpoints.length === 0) {
    return breakpoints;
  }
  var property = "maxWidth" in breakpoints[0] ? "maxWidth" : "minWidth";
  var sorted = _toConsumableArray(breakpoints).sort(function (a, b) {
    return getBreakpointValue(getSize({
      size: b[property],
      sizes: theme.breakpoints
    })) - getBreakpointValue(getSize({
      size: a[property],
      sizes: theme.breakpoints
    }));
  });
  return property === "minWidth" ? sorted.reverse() : sorted;
}
export { getSortedBreakpoints };